/**
 * De iconen uit de designbundle. Daar zijn het losse divs met randen en
 * gradients; hier zijn het svg's met dezelfde vorm en maat, zodat ze meeschalen
 * en `currentColor` volgen.
 */

type IconProps = {
  className?: string
}

/** Het vierkant van vier blokjes: de galerij, en "mijn bestanden". */
export function GridIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" className={className} fill="currentColor">
      <rect x="0" y="0" width="7" height="7" rx="1" />
      <rect x="9" y="0" width="7" height="7" rx="1" />
      <rect x="0" y="9" width="7" height="7" rx="1" />
      <rect x="9" y="9" width="7" height="7" rx="1" />
    </svg>
  )
}

/** De open cirkel van de challenges. */
export function TargetIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="8" cy="8" r="7" />
    </svg>
  )
}

export function CameraIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 20"
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <rect x="1" y="3" width="22" height="16" rx="3" />
      <circle cx="12" cy="11" r="4.5" />
    </svg>
  )
}

export function PlayIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className} fill="currentColor">
      <path d="M8 5.5v13l11-6.5z" />
    </svg>
  )
}

export function CheckIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 8.5 6.5 12 13 4.5" />
    </svg>
  )
}

export function UploadArrowIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 19V5" />
      <path d="m5 12 7-7 7 7" />
    </svg>
  )
}

/** De ronde spinner met een open kwart, zoals in het ontwerp. */
export function Spinner({ className }: IconProps) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className ?? ''}`}
    />
  )
}

/**
 * Het plusje op de toevoegknop. Als vector en niet als het teken ＋: dat is een
 * volle-breedte plus uit het CJK-blok, en die staat in elk lettertype net
 * anders — te dik, of net niet gecentreerd naast een woord.
 */
export function PlusIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  )
}

/** De videocamera naast "Video opnemen". */
export function VideoIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <rect
        x="2.5"
        y="6.5"
        width="13"
        height="11"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M15.5 10.5 20.4 8a.8.8 0 0 1 1.1.7v6.6a.8.8 0 0 1-1.1.7l-4.9-2.5z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  )
}
